import {
  COURSE_LIST_ALL_FAIL,
  COURSE_LIST_ALL_REQUEST,
  COURSE_LIST_ALL_SUCCESS,
} from "../Constant/CourseConstant";
import api from "../Core/api";

export const listCourses = (CourseJson) => async (dispatch) => {
  try {
    dispatch({
      type: COURSE_LIST_ALL_REQUEST,
    });
    const { data } = await api.get(`/courses`, CourseJson);
    const res = data.Result;

    dispatch({
      type: COURSE_LIST_ALL_SUCCESS,
      payload: res,
      total: data?.Total_Courses,
    });
  } catch (error) {
    dispatch({
      type: COURSE_LIST_ALL_FAIL,
      payload:
        error.response && error.response.data.Result
          ? error.response.data.Result
          : error.message,
    });
  }
};

export const CourseFIlterData = () => async (dispatch) => {
  try {
    const { data } = await api.post("/");
  } catch (ex) {}
};

export const SelectStudentPackage = (PackId) => async (dispatch) => {
  dispatch({ type: "PACKAGE_SELECTED_REQ" });
  dispatch({ type: "PACKAGE_SELECTED", payload: PackId });
};
